import {
  Box,
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Formik, ErrorMessage } from "formik";
import React, { useEffect, useState } from "react";
import { useStyles } from "./styles";
import Pen from "../../../assets/images/CourseManagement/pen.svg";
import Close from "../../../assets/images/CourseManagement/close.svg";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import * as Yup from "yup";
import CustomExpandMore from "../../../common/CustomExpandMore";
import { useNavigate } from "react-router-dom";
import useStaff from "../../../Hooks/staff";
import useAuthStore from "../../../Hooks/auth";
import { TablePagination } from "@mui/material";
import useAttendance from "../../../Hooks/attendance";
import Loader from "../../../common/Loader";

const columns = [
  {
    id: "id",
    label: "S.No",
    align: "center",
    sortby: true,
  },
  {
    id: "date",
    label: "Date",
    align: "center",
    sortby: true,
  },
  {
    id: "foreNoon",
    sortby: true,
    label: "Fore Noon",
    align: "center",
  },
  {
    // id: "afterNoon",
    sortby: true,
    label: "After Noon",
    align: "center",
  },
];

const attendanceSchema = Yup.object().shape({
  month: Yup.string().required("* Please select month"),
  year: Yup.string().required("* Please select year"),
});

const Attendance = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const {
    getStaffAttendanceAction,
    resetStaffAttendanceAction,
    staffPersonalInfo,
    facultyAttendance,
  } = useStaff();

  const { loading, uploadStudentAttendanceAction } = useAttendance();
  const { userId,institutionId } = useAuthStore();

  const years = React.useCallback(() => {
    const yearList = [];
    const d = new Date();
    let currentYear = d.getFullYear();
    for (
      let yearOption = currentYear;
      yearOption >= currentYear - 15;
      yearOption--
    ) {
      yearList.push(yearOption);
    }

    return yearList;
  }, []);

  useEffect(() => {
    resetStaffAttendanceAction();
  }, []);

  const staffAttendanceValue = {
    idFaculty: userId,
    month: "",
    year: "",
    limit: 10,
    offset: 0,
  };

  const handleFile = (e) => {
    // get the files
    let file = e.target.files[0];
    const { target = {} } = e || {};

    // Make new FileReader
    let reader = new FileReader();

    // Convert the file to base64 text
    reader.readAsDataURL(file);
    reader.onload = () => {
      uploadStudentAttendanceAction([

        reader.result.substr(reader.result.indexOf(",") + 1),
        institutionId
      ])
      target.value = "";
    };
  };
  //console.log(userId, "userId");

  return (
    <>
      {loading && <Loader />}
      <Stack className={classes.myattendance}>
        <Grid container>
          <Grid item lg={8} sm={12}>
            <Stack>
              <Box sx={{ width: "100%" }}>
                <Paper
                  sx={{
                    width: "100%",
                    borderRadius: "20px",
                    filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                    boxShadow: "none",
                  }}
                >
                  <Stack sx={{ p: 4 }}>
                    <Formik
                      initialValues={staffAttendanceValue}
                      validationSchema={attendanceSchema}
                      validateOnBlur={false}
                      validateOnChange={false}
                      onSubmit={(values) => {
                        getStaffAttendanceAction(values);
                      }}
                    >
                      {(formik) => {
                        const {
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          values,
                        } = formik;
                        return (
                          <form onSubmit={handleSubmit}>
                            <Grid
                              item
                              container
                              lg={12}
                              md={12}
                              xl={12}
                              sx={{ py: 2, width: "100%" }}
                              className={classes.form_add_course}
                            >
                              <Grid
                                container
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                sx={{
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: 1,
                                  mb: 2,
                                }}
                              >
                                <Grid item md={1} lg={1} xl={1}>
                                  <Typography className={classes.label}>
                                    <span style={{ fontWeight: "bold" }}>
                                      Date
                                    </span>
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  md={2}
                                  lg={3}
                                  xl={2}
                                  sx={{ textAlign: "start" }}
                                >
                                  <Select
                                    id="month"
                                    name="month"
                                    placeholder="Please select the Calender Month"
                                    IconComponent={CustomExpandMore}
                                    displayEmpty
                                    sx={{
                                      width: 180,
                                    }}
                                    className={
                                      errors.month && touched.month
                                        ? classes.inputError
                                        : classes.inputNoError
                                    }
                                    onBlur={handleBlur}
                                    onClick={() => years()}
                                    onChange={(e) => handleChange(e)}
                                    value={values.month}
                                  >
                                    <MenuItem value="" disabled>
                                      Select Month
                                    </MenuItem>
                                    <MenuItem value="1">JAN</MenuItem>
                                    <MenuItem value="2">FEB</MenuItem>
                                    <MenuItem value="3">MAR</MenuItem>
                                    <MenuItem value="4">APR</MenuItem>
                                    <MenuItem value="5">MAY</MenuItem>
                                    <MenuItem value="6">JUN</MenuItem>
                                    <MenuItem value="7">JULY</MenuItem>
                                    <MenuItem value="8">AUG</MenuItem>
                                    <MenuItem value="9">SEPT</MenuItem>
                                    <MenuItem value="10">OCT</MenuItem>
                                    <MenuItem value="11">NOV</MenuItem>
                                    <MenuItem value="12">DEC</MenuItem>
                                  </Select>
                                  <ErrorMessage
                                    name="month"
                                    component="span"
                                    className={classes.error}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  md={2}
                                  lg={3}
                                  xl={2}
                                  sx={{ textAlign: "start" }}
                                >
                                  <Select
                                    id="year"
                                    name="year"
                                    placeholder="Please select the Calender Year"
                                    IconComponent={CustomExpandMore}
                                    displayEmpty
                                    sx={{
                                      width: 180,
                                    }}
                                    className={
                                      errors.year && touched.year
                                        ? classes.inputError
                                        : classes.inputNoError
                                    }
                                    onBlur={handleBlur}
                                    onChange={(e) => handleChange(e)}
                                    value={values.year}
                                  >
                                    <MenuItem value="" disabled>
                                      Select Year
                                    </MenuItem>
                                    {years().map((val, index) => {
                                      return (
                                        <MenuItem value={val} key={index}>
                                          {val}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                  <ErrorMessage
                                    name="year"
                                    component="span"
                                    className={classes.error}
                                  />
                                </Grid>
                                <Grid
                                  item
                                  md={4}
                                  lg={4}
                                  xl={2}
                                  sx={{ textAlign: "end" }}
                                >
                                  <Button
                                    type="submit"
                                    sx={{
                                      px: 1,
                                      py: 1,
                                      borderRadius: "80px",
                                    }}
                                    className={classes.add_arrival}
                                  >
                                    Submit
                                  </Button>
                                </Grid>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                xl={12}
                                sx={{ textAlign: "end" }}
                              >
                                {/* <Button
                                  component="label"
                                  sx={{
                                    px: 1,
                                    py: 1,
                                    borderRadius: "50px",
                                  }}
                                  className={classes.add_attendance}
                                >
                                  Upload Biometric Attendance
                                  <input
                                    type="file"
                                    hidden
                                    onChange={(e) => handleFile(e)}
                                  />
                                </Button> */}
                              </Grid>
                            </Grid>
                          </form>
                        );
                      }}
                    </Formik>
                  </Stack>
                </Paper>
              </Box>
            </Stack>
            <Stack sx={{ marginTop: "20px" }}>
              <Box sx={{ width: "100%" }}>
                <Paper
                  sx={{
                    width: "100%",
                    borderRadius: "20px",
                    filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                    boxShadow: "none",
                  }}
                >
                  <Stack sx={{ p: 4 }}>
                    <TableContainer sx={{ maxHeight: 440 }}>
                      <Table
                        aria-label="sticky table"
                        className={classes.root}
                        style={{ padding: 0 }}
                      >
                        <TableHead>
                          <TableRow classes={{ root: classes.thead }}>
                            {columns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                  minWidth: column.minWidth,
                                  paddingLeft: column.paddingLeft,
                                }}
                                classes={{ root: classes.columnData }}
                              >
                                {column.label}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>

                        <TableBody classes={{ root: classes.tBody }}>
                          {facultyAttendance?.staffAttendance?.length > 0 ? (
                            facultyAttendance?.staffAttendance?.map(
                              (_el, index) => (
                                <TableRow
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={index}
                                >
                                  {columns.map((column) => {
                                    const value = _el[column.id];
                                    //console.log("value", value);
                                    return (
                                      <TableCell
                                        key={column.id}
                                        align={column.align}
                                      >
                                        {column.id === "select" ? (
                                          <Stack sx={{ alignItems: "center" }}>
                                            <span>{index + 1}</span>
                                          </Stack>
                                        ) : column.id === "id" ? (
                                          index + 1
                                        ) : column.id === "date" ? (
                                          _el.attendanceDate
                                        ) : column.id === "foreNoon" ? (
                                          _el.forenoonStatus == 1 ? (
                                            <Grid
                                              display="flex"
                                              direction="row"
                                              justifyContent="center"
                                            >
                                              {" "}
                                              <p
                                                style={{
                                                  color: "green",
                                                  paddingRight: "20px",
                                                }}
                                              >
                                                Present
                                              </p>
                                              <p style={{ color: "black" }}>
                                                Absent
                                              </p>{" "}
                                            </Grid>
                                          ) : (
                                            <Grid
                                              display="flex"
                                              direction="row"
                                              justifyContent="center"
                                            >
                                              {" "}
                                              <p
                                                style={{
                                                  color: "black",
                                                  paddingRight: "20px",
                                                }}
                                              >
                                                Present
                                              </p>
                                              <p style={{ color: "red" }}>
                                                Absent
                                              </p>{" "}
                                            </Grid>
                                          )
                                        ) : column.id === "afterNoon" ? (
                                          _el.afternoonStatus == 1 ? (
                                            <Grid
                                              display="flex"
                                              direction="row"
                                              justifyContent="center"
                                            >
                                              {" "}
                                              <p
                                                style={{
                                                  color: "green",
                                                  paddingRight: "20px",
                                                }}
                                              >
                                                Present
                                              </p>
                                              <p style={{ color: "black" }}>
                                                Absent
                                              </p>{" "}
                                            </Grid>
                                          ) : (
                                            <Grid
                                              display="flex"
                                              direction="row"
                                              justifyContent="center"
                                            >
                                              {" "}
                                              <p
                                                style={{
                                                  color: "black",
                                                  paddingRight: "20px",
                                                }}
                                              >
                                                Present
                                              </p>
                                              <p style={{ color: "red" }}>
                                                Absent
                                              </p>{" "}
                                            </Grid>
                                          )
                                        ) : (
                                          ""
                                        )}
                                      </TableCell>
                                    );
                                  })}
                                </TableRow>
                              )
                            )
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={columns.length}
                                sx={{ borderBottom: "none" }}
                              >
                                <Stack
                                  sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  No Data
                                </Stack>
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                        {/* <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                          colSpan={3}
                          count={rows.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          SelectProps={{
                            inputProps: {
                              'aria-label': 'rows per page',
                            },
                            native: true,
                          }}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={TablePaginationActions}
                        />
                      </TableRow>
                    </TableFooter> */}
                      </Table>
                    </TableContainer>
                  </Stack>
                </Paper>
              </Box>
            </Stack>
          </Grid>
          <Grid item lg={4} sm={12}></Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default Attendance;
